






















































































































import queries from "@/gql/queries.coffee"
import moment from "moment"
import diff from "diff"
moment.locale("fr")
  
export default {
    "name": "StateAnswerAccepted"
    "props": {
        "context": {
            "type": Object
            "required": true
        }
        "review": {
            "type": Object,
            "required": true
        }
        "human_created_on": String
    }
    computed:
        human_published_on: ()->
                return moment(@context.updated_on).fromNow()
        text_history_ordered: ()->
            ret = []
            if @context.data.text_history?
                ret = @context.data.text_history.sort (a, b)->
                    new Date(b.date).getTime() - new Date(a.date).getTime()        
            return ret
    methods:
        modified: (before, after)->
            if not before?
                before = ""
            if not after?
                after = ""
            text_diff = diff.diffWords(before, after)
            out = ""
            for part in text_diff
                if part.added
                    out += '<span style="background-color:#cefacb;">'+part.value+'</span>'
                else if part.removed
                    out += '<span style="background-color:#facbcb;">'+part.value+'</span>'
                else 
                    out += part.value
            return out
        
        copy_publish: (text)->
            @copy(text)
            url = ""
            queries.run('get_connection_for_review', [@context.review.uid]).then (resp)->
                data = JSON.parse(resp.body.data.connection_set_for_review)            
                window.open(data.establishment_link , '_blank').focus();

        copy: (text)->
            textArea = document.createElement("textarea");
            textArea.value = text;
            textArea.style.top = "0";
            textArea.style.left = "0";
            textArea.style.position = "fixed";
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            document.execCommand('copy');
            document.body.removeChild(textArea);
            this.$store.dispatch("notify",{
                level: "success",
                text: "Copié!",
                seconds: 2
            })

        delete_state: ()->
            @$emit("state:delete_state")

}
